"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const d3 = __importStar(require("d3"));
const lodash_1 = __importDefault(require("lodash"));
const canvas_1 = require("canvas");
const resize_observer_polyfill_1 = __importDefault(require("resize-observer-polyfill"));
const constants_1 = require("../../constants");
const chart_helpers_1 = require("../../util/chart.helpers");
const Expander_1 = __importDefault(require("../Expander"));
const Tooltip_1 = __importDefault(require("../Tooltip"));
const colours_module_scss_1 = __importDefault(require("../../styles/colours.module.scss"));
require("./DotPlot.scss");
const common_module_scss_1 = __importDefault(require("../../styles/common.module.scss"));
const CanvasDrawer_1 = __importDefault(require("../../util/CanvasDrawer"));
const InfoTooltip_1 = __importDefault(require("../InfoTooltip"));
const SourcesAndFootnotes_1 = __importDefault(require("../SourcesAndFootnotes"));
const error_1 = require("../error");
const transitions_1 = require("../../util/transitions");
const dotColors = [colours_module_scss_1.default.chartcolourgrey, colours_module_scss_1.default.chartcolourdefault0];
class DotPlot extends Expander_1.default {
  constructor(container, cssPrefix) {
    super(container, 1000, 300, cssPrefix || 'dot-plot', false);
    this.chartType = constants_1.CHART_TYPES.DotPlot;
    this.cssPrefix = cssPrefix || 'dot-plot';
    this.initialDraw = true;
    this.margins = {
      top: 25,
      bottom: 20,
      left: 10,
      right: 20,
      labelPadding: 20
    };
    this.ySpacing = 30;
    this.xScale = d3.scaleLinear();
    this.yScale = d3.scalePoint();
    this.startKey = null;
    this.endKey = null;
    if (container === undefined) {
      this.draw = this.drawCanvas;
      return;
    }
    this.title = container.insert('div', 'div.expandable').classed('chart-title', true);
    this.title.append('span').classed('chart-title-main', true);
    this.subtitle = container.insert('div', 'div.expandable').classed('chart-subtitle', true);
    this.sourceContainer = container.append('div');
    this.sources = new SourcesAndFootnotes_1.default(this.sourceContainer);
    this.tooltip = new Tooltip_1.default(container);
    this.initGroups();
    this.ro = new resize_observer_polyfill_1.default(entries => {
      entries.forEach(entry => {
        const {
          width: containerWidth
        } = entry.contentRect;
        requestAnimationFrame(() => {
          this.resizeContent(containerWidth);
        });
      });
    });
    this.ro.observe(container.node());
  }
  initGroups() {
    this.svg.append('g').classed('axis', true).classed(`${this.cssPrefix}-xaxis`, true);
    const chartGroup = this.svg.append('g').classed(`${this.cssPrefix}-chart`, true);
    chartGroup.append('g').classed(`${this.cssPrefix}-chart-labels`, true);
    chartGroup.append('g').classed(`${this.cssPrefix}-chart-area`, true);
    this.initExpand();
    error_1.initError.call(this);
  }
  static isTopOrBottom(i, _ref) {
    let {
      data = [],
      topMetrics = [],
      bottomMetrics = []
    } = _ref;
    return i < topMetrics.length || i >= data.length - bottomMetrics.length;
  }
  createScales(data, params, margins, metricHeight) {
    let topMetrics = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    let bottomMetrics = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
    const sectionSpacing = 10;
    const [minValue, maxValue] = d3.extent((0, chart_helpers_1.allDataPoints)(lodash_1.default.flattenDeep([data, topMetrics, bottomMetrics]), params.startDate, params.endDate, data[0] ? data[0].metric.xType : 'years'), d => d.value);
    const outerPadding = 0.5;
    let dataXDomain = [Math.min(0, minValue), Math.max(0, maxValue)];
    if (params.floatingAxis) {
      // finds the extremes for data with the selected key
      const [keyMinValue, keyMaxValue] = d3.extent(lodash_1.default.filter((0, chart_helpers_1.allDataPoints)(lodash_1.default.flattenDeep([data, topMetrics, bottomMetrics]), params.startDate, params.endDate, data[0] ? data[0].metric.xType : 'years'), d => DotPlot.keyMatches(d.key, this.startKey, d.metric.metric.xType) || DotPlot.keyMatches(d.key, this.endKey, d.metric.metric.xType)), d => d.value);
      dataXDomain = [keyMinValue, keyMaxValue];
    }
    const xScale = d3.scaleLinear().domain(dataXDomain).nice();
    let startY = margins.top;
    let ySpacing = metricHeight;
    let topMetricYScale;
    let bottomMetricYScale;
    if (params.autosize) {
      const chartHeight = this.chartArea(0, data, params).height;
      const sectionsSpacing = (topMetrics.height ? sectionSpacing : 0) + (bottomMetrics.height ? sectionSpacing : 0);
      this.ySpacing = (chartHeight - sectionsSpacing) / (data.length + topMetrics.length + bottomMetrics.length);
      ySpacing = this.ySpacing;
    }
    const newTopMetrics = !params.sortRows ? topMetrics : (0, lodash_1.default)(topMetrics).orderBy(d => {
      const maxSet = d.metric.data.find(v => DotPlot.keyMatches(v.key, this.endKey, d.metric.xType));
      return maxSet && Number.isFinite(maxSet.value) ? maxSet.value : -Infinity;
    }, 'desc').value();
    const newBottomMetrics = !params.sortRows ? bottomMetrics : (0, lodash_1.default)(bottomMetrics).orderBy(d => {
      const maxSet = d.metric.data.find(v => DotPlot.keyMatches(v.key, this.endKey, d.metric.xType));
      return maxSet && Number.isFinite(maxSet.value) ? maxSet.value : -Infinity;
    }, 'desc').value();
    const newData = !params.sortRows ? data : (0, lodash_1.default)(data).orderBy(d => {
      const maxSet = d.metric.data.find(v => DotPlot.keyMatches(v.key, this.endKey, d.metric.xType));
      return maxSet && Number.isFinite(maxSet.value) ? maxSet.value : -Infinity;
    }, 'desc').value();
    if (newTopMetrics.length) {
      topMetricYScale = d3.scalePoint().padding(outerPadding).domain(newTopMetrics.map(chart_helpers_1.uniqueMetricMap)).range([startY, startY + newTopMetrics.length * ySpacing]);
      startY += newTopMetrics.length * ySpacing + sectionSpacing;
    }
    const mainMetricYScale = d3.scalePoint().padding(outerPadding).domain(newData.map(chart_helpers_1.uniqueMetricMap)).range([startY, startY + data.length * ySpacing]);
    startY += data.length * ySpacing;
    if (newBottomMetrics.length) {
      startY += +sectionSpacing;
      bottomMetricYScale = d3.scalePoint().padding(outerPadding).domain(newBottomMetrics.map(chart_helpers_1.uniqueMetricMap)).range([startY, startY + newBottomMetrics.length * ySpacing]);
      startY += newBottomMetrics.length * ySpacing;
    }
    const yScale = d => {
      if (topMetricYScale && Number.isFinite(topMetricYScale(d))) {
        return topMetricYScale(d);
      }
      if (bottomMetricYScale && Number.isFinite(bottomMetricYScale(d))) {
        return bottomMetricYScale(d);
      }
      return mainMetricYScale(d);
    };
    yScale.range = () => [margins.top, startY];
    return {
      xScale,
      yScale
    };
  }
  chartArea(leftPadding, data, params) {
    const {
      margins
    } = params;
    return {
      width: this.width - margins.right - (leftPadding || 0),
      height: this.height(data, params) - margins.top - margins.bottom
    };
  }
  height(data, params) {
    if (params.autosize) {
      return this.container.node().getBoundingClientRect().height - this.title.node().getBoundingClientRect().height - this.subtitle.node().getBoundingClientRect().height - this.sourceContainer.node().getBoundingClientRect().height;
    }
    return data.length * this.ySpacing + this.margins.top + this.margins.bottom;
  }
  setDropdownSelected(key, dropdownNumber) {
    if (dropdownNumber === undefined) {
      this.dropdownSelected = key;
      return;
    }
    if (dropdownNumber === 0) {
      this.startKey = key;
    } else if (dropdownNumber === 1) {
      this.endKey = key;
    }
  }
  async data(promises, options) {
    const fetched = await error_1.tryChartPromises.call(this, promises);
    if (!fetched) return null;
    const {
      data,
      topMetrics,
      bottomMetrics,
      parent
    } = fetched;
    let filtered = data.filter(d => d.metric.data && d.metric.data.length > 0);
    const startDate = options.startDate || options.startYear;
    const endDate = options.endDate || options.endYear;
    const dateFilter = date => {
      if (date.xType === 'items') return true;
      if (startDate && date.key.getTime() < (0, chart_helpers_1.dateParser)(startDate, date.xType).getTime()) {
        return false;
      }
      if (endDate && date.key.getTime() > (0, chart_helpers_1.dateParser)(endDate, date.xType).getTime()) {
        return false;
      }
      return true;
    };
    let keysAreDates = true;
    const getKeys = d => {
      if (d.metric.xType && d.metric.xType.toLowerCase() === 'items') keysAreDates = false;
      return d.metric.data.map(_ref2 => {
        let {
          key
        } = _ref2;
        return {
          key,
          xType: d.metric.xType
        };
      });
    };
    let keys = (0, lodash_1.default)(filtered).flatMap(getKeys).filter(dateFilter);
    if (keysAreDates) {
      keys = keys.sortBy('key').map(date => (0, chart_helpers_1.dateFormat)(date.key, date.xType));
    }
    keys = keys.uniq().value();
    let overlappingKeys = (0, lodash_1.default)(filtered).map(getKeys).thru(k => lodash_1.default.intersectionWith(...k, (a, b) => {
      if (!keysAreDates) return a.key === b.key;
      return a.key.getTime() === b.key.getTime();
    })).filter(dateFilter);
    if (keysAreDates) {
      overlappingKeys = overlappingKeys.sortBy('key').map(date => (0, chart_helpers_1.dateFormat)(date.key, date.xType));
    }
    if (this.startKey === null || !keys.includes(this.startKey)) {
      if (options.selectedYear !== undefined && keys.includes(options.selectedYear.toString())) {
        this.startKey = options.selectedYear;
      } else if (options.selectedDropdown !== undefined && keys.includes(options.selectedDropdown.toString())) {
        this.startKey = options.selectedDropdown;
      } else if (options.defaultToOverlapYears) {
        this.startKey = lodash_1.default.first(overlappingKeys.value());
      } else {
        this.startKey = lodash_1.default.first(keys);
      }
    }
    if (this.endKey === null || !keys.includes(this.endKey)) {
      if (options.selectedYear2 !== undefined && keys.includes(options.selectedYear2.toString())) {
        this.endKey = options.selectedYear2;
      } else if (options.selectedDropdown2 !== undefined && keys.includes(options.selectedDropdown2.toString())) {
        this.endKey = options.selectedDropdown2;
      } else if (options.defaultToOverlapYears) {
        this.endKey = lodash_1.default.last(overlappingKeys.value());
      } else {
        this.endKey = lodash_1.default.last(keys);
      }
    }
    const shouldSort = options.sortRows !== undefined ? options.sortRows : true;
    filtered = !shouldSort ? filtered : (0, lodash_1.default)(filtered).orderBy(d => {
      const maxSet = d.metric.data.find(v => DotPlot.keyMatches(v.key, this.endKey, d.metric.xType));
      return maxSet && Number.isFinite(maxSet.value) ? maxSet.value : -Infinity;
    }, 'desc').value();
    return {
      data: filtered,
      topMetrics: topMetrics || [],
      bottomMetrics: bottomMetrics || [],
      parent,
      keys
    };
  }
  getDrawParams(_ref3) {
    let {
      data,
      parent,
      options: {
        hideAxisLabels = false,
        hideGridlines = false,
        selectableYears = true,
        selectableDropdowns = true,
        sortRows = true,
        primaryColor = colours_module_scss_1.default.chartcolourdefault0,
        secondaryColor = colours_module_scss_1.default.chartColourgrey,
        axisTextColor = null,
        gridColor = null,
        labelColor = null,
        metricHeight = data[0].allStates === true ? 17 : 30,
        autosize = false,
        defaultToOverlapYears = false,
        expanded = false,
        uncollapsible = false,
        hideTitle = false,
        floatingAxis = true,
        showSourcesAndFootnotes = true,
        transition = false,
        transitionDuration = 1000,
        ...otherOptions
      }
    } = _ref3;
    return {
      ...(0, chart_helpers_1.getDefaultDrawParams)({
        data,
        parent,
        options: otherOptions
      }, this.margins),
      hideAxisLabels,
      hideGridlines,
      selectableYears,
      selectableDropdowns,
      sortRows,
      primaryColor,
      secondaryColor,
      axisTextColor,
      gridColor,
      labelColor,
      metricHeight,
      autosize,
      defaultToOverlapYears,
      expanded,
      uncollapsible,
      transition,
      transitionDuration,
      hideTitle,
      floatingAxis,
      showSourcesAndFootnotes
    };
  }
  async draw(promises) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const allData = await this.data(promises, options);
    if (!allData) return false;
    const {
      data,
      topMetrics,
      bottomMetrics,
      parent,
      keys
    } = allData;
    const optionParams = this.getDrawParams({
      data,
      parent,
      options
    });
    const drawParams = {
      data,
      topMetrics,
      bottomMetrics,
      parent,
      params: optionParams,
      keys
    };
    if (optionParams.titleVerticalPosition === 'top') {
      this.title.classed('below', false);
      this.container.node().insertBefore(this.title.node(), this.svg.node().parentNode);
      this.container.node().insertBefore(this.subtitle.node(), this.svg.node().parentNode);
    } else if (optionParams.titleVerticalPosition === 'bottom') {
      this.title.classed('below', true);
      this.container.node().append(this.title.node());
      this.container.node().append(this.subtitle.node());
      this.container.node().append(this.sourceContainer.node());
    }
    this.drawContent(drawParams);
    return true;
  }
  resizeContent(newWidth) {
    if (this.cachedParams && (this.cachedParams.params.autosize || this.width !== newWidth)) {
      this.drawContent(this.cachedParams, false);
    }
  }
  redrawContent() {
    if (this.cachedParams) {
      this.drawContent(this.cachedParams);
    }
  }
  drawContent(drawParams) {
    let overrideTransition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    this.cachedParams = drawParams;
    const {
      data,
      topMetrics,
      bottomMetrics,
      params
    } = drawParams;
    const shouldTransition = overrideTransition ?? params.transition;
    this.width = this.container.node().getBoundingClientRect().width;
    this.ySpacing = params.metricHeight;
    const allData = lodash_1.default.concat(topMetrics || [], data, bottomMetrics || []);
    const paramsWithSorted = {
      ...drawParams,
      data: allData
    };
    if (!params.hideTitle) {
      chart_helpers_1.drawTitle.call(this, this.title, this.subtitle, paramsWithSorted, this.startKey, this.endKey);
    }
    if (params.showSourcesAndFootnotes) {
      this.sources.draw(allData, params);
    }
    // this.container.select('.expandable').style('height', params.autosize ? '100%' : null);
    const {
      xScale,
      yScale
    } = this.createScales.call(this, data, params, params.margins, this.ySpacing, topMetrics, bottomMetrics);
    this.xScale = xScale;
    this.yScale = yScale;
    this.drawEntries(paramsWithSorted, shouldTransition);
    this.drawAxis(paramsWithSorted, shouldTransition);
    this.drawSectionLines({
      data,
      topMetrics,
      bottomMetrics,
      params
    }, yScale, shouldTransition);
    if (params.info && params.info.position === 'chart') {
      InfoTooltip_1.default.inChart(this.container, params);
    }
    this.initialDraw = false;
    this.drawExpander(allData, params, () => this.drawContent(drawParams));
  }
  static keyMatches(d, selected, xType) {
    if (xType && xType.toLowerCase() === 'items') {
      return d === selected;
    }
    if (!selected.getTime) {
      return d.getTime() === (0, chart_helpers_1.dateParser)(selected, xType).getTime();
    }
    return d.getTime() === selected.getTime();
  }
  static valueAccessor(d, key) {
    const point = d.metric.data.find(v => DotPlot.keyMatches(v.key, key, d.metric.xType));
    return point || null;
  }
  xAccessor(d, key) {
    const point = DotPlot.valueAccessor(d, key);
    return point ? this.xScale(point.value) : null;
  }
  leftAccessor(d) {
    return this.xAccessor(d, this.startKey);
  }
  rightAccessor(d) {
    return this.xAccessor(d, this.endKey);
  }
  yAccessor(d) {
    return this.yScale((0, chart_helpers_1.uniqueMetricMap)(d));
  }
  static entryOpacity(d, i, _ref4) {
    let {
      data,
      topMetrics,
      bottomMetrics
    } = _ref4;
    const someSelectedStates = lodash_1.default.some(data, dd => dd.selectedState);
    if (!someSelectedStates) {
      return null;
    }
    if (d.selectedState || DotPlot.isTopOrBottom(i, {
      data,
      topMetrics,
      bottomMetrics
    })) {
      return null;
    }
    return 0.4;
  }
  ellipsizeWidth(_ref5) {
    let {
      data
    } = _ref5;
    const hasCustomLabels = lodash_1.default.some(data, d => d.labelText !== undefined);
    const reactiveWidth = this.width * (hasCustomLabels ? 0.5 : 0.4);
    return reactiveWidth;
  }
  showTooltip(drawParams, d, key, colour) {
    const containerDim = this.container.node().getBoundingClientRect();
    const svgDim = this.svg.node().getBoundingClientRect();
    const point = DotPlot.valueAccessor(d, key);
    const x = this.xAccessor(d, key);
    const y = svgDim.top - containerDim.top + this.yAccessor(d);
    const format = (0, chart_helpers_1.tooltipFormat)(drawParams);
    const dataLabel = (d.metric.lexiconName || d.metric.name) + (d.metric.geo_id && d.metric.geo_id !== 'US' ? ` in ${d.metric.geo_name}` : '');
    const topContent = {
      title: {
        value: d.tooltipTitle ?? dataLabel
      },
      subtitle: {
        value: key
      }
    };
    this.tooltip.draw(x, y, topContent, [{
      type: 'value',
      value: format(point.value)
    }], {
      primaryColour: colour
    });
  }
  drawEntries(drawParams) {
    let transition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const {
      data,
      params
    } = drawParams;
    const labelMode = (0, chart_helpers_1.getLabelTextMode)(data, params);
    // draw left labels
    const chartAreaLeft = this.drawEntryLabels(drawParams, labelMode, transition);
    const area = this.chartArea(chartAreaLeft, data, params);
    this.xScale.range([chartAreaLeft, chartAreaLeft + area.width]);
    const chartGroup = this.svg.select(`g.${this.cssPrefix}-chart`);
    const chartAreaGroup = chartGroup.select(`g.${this.cssPrefix}-chart-area`);
    const entriesUpdate = chartAreaGroup.selectAll(`g.${this.cssPrefix}-entry`).data(data, chart_helpers_1.uniqueMetricMap);
    const entriesEnter = entriesUpdate.enter().append('g').classed(`${this.cssPrefix}-entry`, true).style('opacity', (d, i) => DotPlot.entryOpacity(d, i, drawParams));
    const entriesExit = entriesUpdate.exit();
    const selections = {
      enter: entriesEnter,
      update: entriesUpdate,
      exit: entriesExit
    };
    const circleSizes = {
      bigCircleSize: d => (d.fontSize || params.fontSize) / 14 * 7,
      smallCircleSize: d => (d.fontSize || params.fontSize) / 14 * 5
    };
    this.drawEntryLine(drawParams, selections, circleSizes, transition);
    this.drawRightCircle(drawParams, selections, circleSizes, transition);
    this.drawLeftCircle(drawParams, selections, circleSizes, transition);
    if (transition && !this.initialDraw) {
      entriesUpdate.transition((0, transitions_1.immediateTransition)(params)).style('opacity', (d, i) => DotPlot.entryOpacity(d, i, drawParams));
      entriesExit.transition((0, transitions_1.immediateTransition)(params)).remove();
    } else {
      entriesUpdate.style('opacity', (d, i) => DotPlot.entryOpacity(d, i, drawParams));
      entriesExit.remove();
    }
    chartAreaGroup.selectAll(`g.${this.cssPrefix}-entry`).style('cursor', this.hasAction('click') ? 'pointer' : null);
    return chartAreaLeft;
  }
  drawEntryLabels(drawParams, labelMode) {
    let transition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    const {
      data,
      params
    } = drawParams;
    const chart = this;
    const chartGroup = this.svg.select(`g.${this.cssPrefix}-chart`);
    const chartLabelGroup = chartGroup.select(`g.${this.cssPrefix}-chart-labels`).attr('transform', `translate(${params.margins.left}, 0)`);
    const labelUpdate = chartLabelGroup.selectAll('text.entry-label').data(data, chart_helpers_1.uniqueMetricMap);
    const labelEnter = labelUpdate.enter().append('text').classed('entry-label', true).style('font-size', `${params.fontSize}px`).text(d => (0, chart_helpers_1.getLabelText)(d, labelMode)).each(function () {
      (0, chart_helpers_1.ellipsize)(d3.select(this), chart.ellipsizeWidth(drawParams));
    });
    const labelExit = labelUpdate.exit();
    const setLabelEnterAttrs = selection => {
      selection.attr('y', d => this.yAccessor(d)).style('fill', d => d.labelColor || params.labelColor).style('font-size', `${params.fontSize}px`).style('opacity', 0);
    };
    const labelEnterTransition = selection => {
      selection.style('opacity', (d, i) => DotPlot.entryOpacity(d, i, drawParams));
    };
    const labelUpdateTransition = selection => {
      selection.attr('y', d => this.yAccessor(d)).style('fill', d => d.labelColor || params.labelColor).style('font-size', `${params.fontSize}px`).style('opacity', (d, i) => DotPlot.entryOpacity(d, i, drawParams));
    };
    if (transition && !this.initialDraw) {
      labelEnter.call(setLabelEnterAttrs).transition((0, transitions_1.delayedTransition)(params)).call(labelEnterTransition);
      labelUpdate.text(d => (0, chart_helpers_1.getLabelText)(d, labelMode)).transition((0, transitions_1.delayedTransition)(params)).call(labelUpdateTransition);
      labelExit.transition((0, transitions_1.immediateTransition)(params)).call(transitions_1.fadeOut).remove();
    } else {
      labelEnter.call(setLabelEnterAttrs).call(labelEnterTransition);
      labelUpdate.call(labelUpdateTransition);
      labelExit.remove();
    }
    const chartAreaLeft = params.margins.left + params.margins.labelPadding + chartLabelGroup.node().getBBox().width;
    labelUpdate.on('mousemove', lodash_1.default.throttle((event, d) => {
      if (this.rightAccessor(d) !== null) {
        this.showTooltip(drawParams, d, this.endKey, (0, chart_helpers_1.primaryColour)(params, d));
      } else if (this.leftAccessor(d) !== null) {
        this.showTooltip(drawParams, d, this.startKey, (0, chart_helpers_1.secondaryColour)(params, d));
      }
    }, constants_1.THROTTLE, {
      trailing: false
    }), {
      passive: true
    }).on('mouseout', () => {
      this.tooltip.hide();
    }, {
      passive: true
    });
    labelEnter.on('mousemove', lodash_1.default.throttle((event, d) => {
      if (this.rightAccessor(d) !== null) {
        this.showTooltip(drawParams, d, this.endKey, (0, chart_helpers_1.primaryColour)(params, d));
      } else if (this.leftAccessor(d) !== null) {
        this.showTooltip(drawParams, d, this.startKey, (0, chart_helpers_1.secondaryColour)(params, d));
      }
    }, constants_1.THROTTLE, {
      trailing: false
    }), {
      passive: true
    }).on('mouseout', () => {
      this.tooltip.hide();
    }, {
      passive: true
    });
    return chartAreaLeft;
  }
  drawLeftCircle(drawParams, _ref6, _ref7) {
    let {
      enter,
      update,
      exit
    } = _ref6;
    let {
      smallCircleSize
    } = _ref7;
    let transition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    const {
      params
    } = drawParams;
    enter.append('circle').classed('entry-left', true);
    const leftUpdate = update.select('.entry-left');
    const leftEnter = enter.select('.entry-left');
    const leftExit = exit.select('.entry-left');
    const setLeftEnterAttrs = selection => {
      selection.attr('r', smallCircleSize).attr('fill', d => (0, chart_helpers_1.secondaryColour)(params, d)).attr('stroke', '#FFF').attr('stroke-width', '1px').attr('cx', (d, i, el) => {
        let oldPos = d3.select(el[i]).attr('cx');
        if (Number.isNaN(oldPos)) {
          oldPos = null;
        }
        const pos = this.leftAccessor(d);
        return pos !== null ? pos : oldPos;
      }).attr('cy', d => this.yAccessor(d)).style('opacity', 0);
    };
    const leftOpacity = selection => {
      selection.style('opacity', d => this.leftAccessor(d) !== null ? 0.7 : 0);
    };
    const leftUpdateFirstTransition = selection => {
      selection.attr('stroke', '#FFF').attr('stroke-width', '1px').attr('cx', (d, i, el) => {
        let oldPos = d3.select(el[i]).attr('cx');
        if (Number.isNaN(oldPos)) {
          oldPos = 0;
        }
        const pos = this.leftAccessor(d);
        return pos !== null ? pos : oldPos;
      });
    };
    const leftUpdateSecondTransition = selection => {
      selection.attr('cy', d => this.yAccessor(d));
    };
    if (transition && !this.initialDraw) {
      leftEnter.call(setLeftEnterAttrs).transition((0, transitions_1.delayedTransition)(params)).call(leftOpacity);
      leftUpdate.attr('r', smallCircleSize).attr('fill', d => (0, chart_helpers_1.secondaryColour)(params, d)).transition((0, transitions_1.immediateTransition)(params)).call(leftUpdateFirstTransition).call(leftOpacity).transition((0, transitions_1.immediateTransition)(params)).call(leftUpdateSecondTransition);
      leftExit.transition((0, transitions_1.immediateTransition)(params)).call(transitions_1.fadeOut);
    } else {
      leftEnter.call(setLeftEnterAttrs).call(leftOpacity);
      leftUpdate.attr('r', smallCircleSize).attr('fill', d => (0, chart_helpers_1.secondaryColour)(params, d)).call(leftUpdateFirstTransition).call(leftUpdateSecondTransition).call(leftOpacity);
    }
    leftEnter.on('mousemove', lodash_1.default.throttle((event, d) => {
      this.showTooltip(drawParams, d, this.startKey, (0, chart_helpers_1.secondaryColour)(params, d));
    }, constants_1.THROTTLE, {
      trailing: false
    }), {
      passive: true
    }).on('mouseout', () => {
      this.tooltip.hide();
    }, {
      passive: true
    });
    leftUpdate.on('mousemove', lodash_1.default.throttle((event, d) => {
      this.showTooltip(drawParams, d, this.startKey, (0, chart_helpers_1.secondaryColour)(params, d));
    }, constants_1.THROTTLE, {
      trailing: false
    }), {
      passive: true
    }).on('mouseout', () => {
      this.tooltip.hide();
    }, {
      passive: true
    });
  }
  drawRightCircle(drawParams, _ref8, _ref9) {
    let {
      enter,
      update,
      exit
    } = _ref8;
    let {
      bigCircleSize
    } = _ref9;
    let transition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    const {
      params
    } = drawParams;
    enter.append('circle').classed('entry-right', true);
    const rightOpacity = selection => {
      selection.style('opacity', d => this.rightAccessor(d) !== null ? 1 : 0);
    };
    const rightUpdate = update.select('.entry-right');
    const rightEnter = enter.select('.entry-right');
    const rightExit = exit.select('.entry-right');
    const setRightEnterAttrs = selection => {
      selection.attr('fill', d => (0, chart_helpers_1.primaryColour)(params, d)).attr('r', bigCircleSize).attr('cx', (d, i, el) => {
        let oldPos = d3.select(el[i]).attr('cx');
        if (Number.isNaN(oldPos)) {
          oldPos = null;
        }
        const pos = this.rightAccessor(d);
        return pos !== null ? pos : oldPos;
      }).attr('cy', this.yAccessor.bind(this)).style('opacity', 0);
    };
    const rightUpdateFirstTransition = selection => {
      selection.attr('cx', (d, i, el) => {
        let oldPos = d3.select(el[i]).attr('cx');
        if (Number.isNaN(oldPos)) {
          oldPos = 0;
        }
        const pos = this.rightAccessor(d);
        return pos !== null ? pos : oldPos;
      }).call(rightOpacity);
    };
    const rightUpdateSecondTransition = selection => {
      selection.attr('cy', this.yAccessor.bind(this));
    };
    if (transition && !this.initialDraw) {
      rightEnter.call(setRightEnterAttrs).transition((0, transitions_1.delayedTransition)(params)).call(rightOpacity);
      rightUpdate.attr('r', bigCircleSize).attr('fill', d => (0, chart_helpers_1.primaryColour)(params, d)).transition((0, transitions_1.immediateTransition)(params)).call(rightUpdateFirstTransition).transition((0, transitions_1.immediateTransition)(params)).call(rightUpdateSecondTransition);
      rightExit.transition((0, transitions_1.immediateTransition)(params)).call(transitions_1.fadeOut);
    } else {
      rightEnter.call(setRightEnterAttrs).call(rightOpacity);
      rightUpdate.attr('r', bigCircleSize).attr('fill', d => (0, chart_helpers_1.primaryColour)(params, d)).call(rightUpdateFirstTransition).call(rightUpdateSecondTransition).call(rightOpacity);
    }
    rightEnter.on('mousemove', lodash_1.default.throttle((event, d) => {
      this.showTooltip(drawParams, d, this.endKey, (0, chart_helpers_1.primaryColour)(params, d));
    }, constants_1.THROTTLE, {
      trailing: false
    }), {
      passive: true
    }).on('mouseout', () => {
      this.tooltip.hide();
    }, {
      passive: true
    });
    rightUpdate.on('mousemove', lodash_1.default.throttle((event, d) => {
      this.showTooltip(drawParams, d, this.endKey, (0, chart_helpers_1.primaryColour)(params, d));
    }, constants_1.THROTTLE, {
      trailing: false
    }), {
      passive: true
    }).on('mouseout', () => {
      this.tooltip.hide();
    }, {
      passive: true
    });
  }
  drawEntryLine(_ref10, _ref11, _ref12) {
    let {
      params
    } = _ref10;
    let {
      enter,
      update,
      exit
    } = _ref11;
    let {
      smallCircleSize
    } = _ref12;
    let transition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    enter.append('line').classed('entry-line', true);
    const lineUpdate = update.select('.entry-line');
    const lineEnter = enter.select('.entry-line');
    const lineExit = exit.select('.exit-line');
    const setLineEnterAttrs = selection => {
      selection.attr('stroke', colours_module_scss_1.default.chartcolourgrey).attr('x1', d => {
        const leftX = this.leftAccessor(d);
        const rightX = this.rightAccessor(d);
        if (leftX === null || rightX === null) {
          return null;
        }
        let radiusAdjust = 0;
        if (leftX > rightX) {
          radiusAdjust = -smallCircleSize(d);
        } else if (leftX < rightX) {
          radiusAdjust = smallCircleSize(d);
        }
        return leftX + radiusAdjust;
      }).attr('y1', this.yAccessor.bind(this)).attr('x2', this.rightAccessor.bind(this)).attr('y2', this.yAccessor.bind(this)).style('opacity', 0);
    };
    const lineOpacity = selection => {
      selection.style('opacity', d => this.leftAccessor(d) !== null && this.rightAccessor(d) !== null ? 0.8 : 0);
    };
    const lineUpdateFirstTransition = selection => {
      selection.attr('stroke', colours_module_scss_1.default.chartcolourgrey).attr('x1', (d, i, el) => {
        const leftX = this.leftAccessor(d);
        const rightX = this.rightAccessor(d);
        const old = d3.select(el[i]).attr('x1');
        if (leftX === null || rightX === null) {
          return old;
        }
        let radiusAdjust = 0;
        if (leftX > rightX) {
          radiusAdjust = -smallCircleSize(d);
        } else if (leftX < rightX) {
          radiusAdjust = smallCircleSize(d);
        }
        return leftX + radiusAdjust;
      }).attr('x2', (d, i, el) => {
        const rightX = this.rightAccessor(d);
        const old = d3.select(el[i]).attr('x2');
        if (rightX === null) {
          return old;
        }
        return rightX;
      });
    };
    const lineUpdateSecondTransition = selection => {
      selection.attr('y1', this.yAccessor.bind(this)).attr('y2', this.yAccessor.bind(this));
    };
    if (transition && !this.initialDraw) {
      lineEnter.call(setLineEnterAttrs).transition((0, transitions_1.delayedTransition)(params)).call(lineOpacity);
      lineUpdate.transition((0, transitions_1.immediateTransition)(params)).call(lineUpdateFirstTransition).call(lineOpacity).transition((0, transitions_1.immediateTransition)(params)).call(lineUpdateSecondTransition);
      lineExit.transition((0, transitions_1.immediateTransition)(params)).call(transitions_1.fadeOut);
    } else {
      lineEnter.call(setLineEnterAttrs).call(lineOpacity);
      lineUpdate.call(lineUpdateFirstTransition).call(lineUpdateSecondTransition).call(lineOpacity);
    }
  }
  drawAxis(drawParams) {
    let transition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const {
      params: {
        hideGridlines,
        fontSize,
        gridColor,
        hideAxisLabels,
        axisTextColor,
        transitionDuration
      }
    } = drawParams;
    const chartAxis = this.svg.select(`g.${this.cssPrefix}-xaxis`);
    const [startY, endY] = this.yScale.range();
    const [startX, endX] = this.xScale.range();
    const axisWidth = endX - startX;
    let ticks = 5;
    if (axisWidth < 150) {
      ticks = 2;
    } else if (axisWidth < 300) {
      ticks = 3;
    }
    if (transition && !this.initialDraw) {
      chartAxis.transition().duration(transitionDuration).attr('transform', `translate(0, ${startY})`).call(d3.axisTop(this.xScale).tickSize(hideGridlines ? 0 : -(endY - startY)).tickFormat(t => (0, chart_helpers_1.valueFormat)(drawParams)(t, {
        ticks: this.xScale.ticks(ticks)
      })).ticks(ticks));
    } else {
      chartAxis.attr('transform', `translate(0, ${startY})`).call(d3.axisTop(this.xScale).tickSize(hideGridlines ? 0 : -(endY - startY)).tickFormat(t => (0, chart_helpers_1.valueFormat)(drawParams)(t, {
        ticks: this.xScale.ticks(ticks)
      })).ticks(ticks));
    }
    chartAxis.selectAll('.tick line').classed('bold', d => !this.xScale.domain().includes(0) && d === 0).style('stroke', gridColor);
    chartAxis.selectAll('.tick text').style('display', hideAxisLabels ? 'none' : null).style('fill', axisTextColor).style('font-size', `${fontSize}px`);
  }
  drawSectionLines(_ref13) {
    let {
      topMetrics,
      data,
      bottomMetrics,
      params
    } = _ref13;
    const lines = [];
    if (topMetrics.length > 0) {
      const y = (this.yAccessor(topMetrics[topMetrics.length - 1]) + this.yAccessor(data[0])) / 2;
      lines.push(y);
    }
    if (bottomMetrics.length > 0) {
      const y = (this.yAccessor(data[data.length - 1]) + this.yAccessor(bottomMetrics[0])) / 2;
      lines.push(y);
    }
    this.svg.selectAll('line.section').data(lines).join('line').classed('section', true).style('stroke', colours_module_scss_1.default.chartcolourgrey).style('stroke-width', 2).attr('y1', lodash_1.default.identity).attr('y2', lodash_1.default.identity).attr('x1', params.margins.left).attr('x2', this.width - params.margins.right);
  }
  async drawCanvas(dataPromises) {
    let chartOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let {
      margin = 40,
      width = 720,
      scale = 3,
      showBranding = true,
      xOffset = 0,
      yOffset = 0
    } = arguments.length > 2 ? arguments[2] : undefined;
    let canvas = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : (0, canvas_1.createCanvas)(width, width);
    const allData = await this.data(dataPromises, chartOptions);
    if (!allData) return null;
    const {
      data,
      parent,
      topMetrics = [],
      bottomMetrics = []
    } = allData;
    const params = this.getDrawParams({
      data,
      parent,
      options: chartOptions
    });
    if (margin !== null) {
      params.margins.left = margin;
      params.margins.right = margin;
    }
    const logoOffset = 20 + margin + 20;
    const titleOffset = params.titleFontSize * parseFloat(common_module_scss_1.default.chartTitleLineHeight);
    const hasSubtitle = params.subtitle !== '';
    const subtitleOffset = hasSubtitle ? params.subtitleFontSize * parseFloat(common_module_scss_1.default.chartSubtitleLineHeight) : 0;
    const footerHeight = (margin ?? 0) + 20;
    const {
      xScale,
      yScale
    } = this.createScales.call(this, data, params, params.margins, params.metricHeight, topMetrics, bottomMetrics);
    const oldWidth = this.width;
    this.width = width;
    // Canvas modification is meant to have side effects
    // eslint-disable-next-line no-param-reassign
    canvas.width = width * scale;
    const chartHeight = params.metricHeight * data.length + params.margins.top + params.margins.bottom;
    // eslint-disable-next-line no-param-reassign
    canvas.height = (chartHeight + logoOffset + titleOffset + subtitleOffset + footerHeight) * scale;
    const context = canvas.getContext('2d');
    context.fillStyle = 'white';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.scale(scale, scale);
    const leftMargin = params.margins.left;
    CanvasDrawer_1.default.drawTitles.call(this, canvas, params, this.startKey, dotColors[0], this.endKey, dotColors[1], xOffset, yOffset + logoOffset);
    const longestLabelWidth = (0, lodash_1.default)([topMetrics, data, bottomMetrics]).map(d => CanvasDrawer_1.default.drawLeftLabels(canvas, d, params, yScale, width, leftMargin, logoOffset + titleOffset + subtitleOffset)).map('longestLabelWidth').max();
    xScale.range([params.margins.left + params.margins.labelPadding + longestLabelWidth, width - params.margins.right]);
    const [startY, endY] = yScale.range();
    const [startX, endX] = xScale.range();
    const axisWidth = endX - startX;
    const ticks = axisWidth > 300 ? 5 : 3;
    const tickLength = Math.abs(endY - startY);
    const axisFormat = t => (0, chart_helpers_1.valueFormat)({
      data,
      parent,
      params
    })(t, {
      ticks: xScale.ticks(ticks)
    });
    CanvasDrawer_1.default.drawAxis(canvas, data, params, xScale, 'top', ticks, tickLength, axisFormat, 0, startY + logoOffset + titleOffset + subtitleOffset);
    const dotsOffset = logoOffset + titleOffset + subtitleOffset;
    if (topMetrics.length > 0) {
      const y = dotsOffset + (this.yAccessor(topMetrics[topMetrics.length - 1]) + this.yAccessor(data[0])) / 2;
      context.strokeStyle = colours_module_scss_1.default.chartcolourgrey;
      context.lineWidth = 2;
      context.beginPath();
      context.moveTo(params.margins.left, y);
      context.lineTo(width - params.margins.right, y);
      context.stroke();
      CanvasDrawer_1.default.drawDots.call(this, canvas, topMetrics, params, this.startKey, this.endKey, xScale, yScale, 0, dotsOffset, dotColors[0], dotColors[1]);
    }
    CanvasDrawer_1.default.drawDots.call(this, canvas, data, params, this.startKey, this.endKey, xScale, yScale, 0, dotsOffset, dotColors[0], dotColors[1]);
    if (bottomMetrics.length > 0) {
      const y = dotsOffset + (this.yAccessor(data[data.length - 1]) + this.yAccessor(bottomMetrics[0])) / 2;
      context.strokeStyle = colours_module_scss_1.default.chartcolourgrey;
      context.lineWidth = 2;
      context.beginPath();
      context.moveTo(params.margins.left, y);
      context.lineTo(width - params.margins.right, y);
      context.stroke();
      CanvasDrawer_1.default.drawDots.call(this, canvas, bottomMetrics, params, this.startKey, this.endKey, xScale, yScale, 0, dotsOffset, dotColors[0], dotColors[1]);
    }
    if (showBranding) {
      await CanvasDrawer_1.default.drawLogo(canvas, width, params, margin);
      CanvasDrawer_1.default.drawFooter(canvas, width, chartHeight + logoOffset + titleOffset + subtitleOffset + 20);
    }
    this.width = oldWidth;
    return canvas;
  }
}
exports.default = DotPlot;